import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const BlogIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.21439 4C4.21382 4 4.21318 4 4.21262 4C4.01397 4 3.82713 4.07743 3.68605 4.21814C3.54341 4.36041 3.46484 4.54984 3.46484 4.75151V16.0202C3.46484 16.4335 3.80238 16.7705 4.21736 16.7715C5.96678 16.7757 8.89777 17.1403 10.9197 19.256V7.46296C10.9197 7.32288 10.884 7.19129 10.8164 7.0824C9.15688 4.41012 5.96777 4.0041 4.21439 4Z"
        fill="currentColor"
      />
      <path
        d="M19.5408 16.0203V4.75151C19.5408 4.54984 19.4622 4.36041 19.3196 4.21814C19.1785 4.07743 18.9915 4 18.7931 4C18.7924 4 18.7918 4 18.7912 4C17.0379 4.00417 13.8488 4.41019 12.1892 7.08247C12.1216 7.19136 12.0859 7.32295 12.0859 7.46303V19.256C14.1079 17.1403 17.0389 16.7757 18.7883 16.7715C19.2032 16.7705 19.5408 16.4335 19.5408 16.0203Z"
        fill="currentColor"
      />
      <path
        d="M21.2499 6.59961H20.7049V16.0211C20.7049 17.0762 19.8452 17.9365 18.7884 17.9391C17.3045 17.9427 14.8578 18.2328 13.125 19.8726C16.1219 19.1389 19.2812 19.6159 21.0816 20.0261C21.3065 20.0773 21.5388 20.0244 21.7189 19.8809C21.8984 19.7377 22.0013 19.5237 22.0013 19.2939V7.35098C22.0014 6.93668 21.6642 6.59961 21.2499 6.59961Z"
        fill="currentColor"
      />
      <path
        d="M2.29641 16.0211V6.59961H1.75145C1.33718 6.59961 1 6.93668 1 7.35098V19.2937C1 19.5235 1.10297 19.7375 1.28245 19.8807C1.46243 20.0242 1.69452 20.0773 1.91969 20.0259C3.72017 19.6156 6.87951 19.1387 9.87626 19.8724C8.14353 18.2326 5.69682 17.9426 4.21294 17.939C3.1562 17.9365 2.29641 17.0762 2.29641 16.0211Z"
        fill="currentColor"
      />
    </svg>
  )
})

BlogIcon.displayName = 'BlogIcon'
